import { render, staticRenderFns } from "./HowToOrder.vue?vue&type=template&id=32456c5e&scoped=true&"
import script from "./HowToOrder.vue?vue&type=script&lang=js&"
export * from "./HowToOrder.vue?vue&type=script&lang=js&"
import style0 from "./HowToOrder.vue?vue&type=style&index=0&id=32456c5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32456c5e",
  null
  
)

export default component.exports